import { render } from "./MarketTrend.vue?vue&type=template&id=f6ff51e0&scoped=true"
import script from "./MarketTrend.vue?vue&type=script&lang=js"
export * from "./MarketTrend.vue?vue&type=script&lang=js"

import "./MarketTrend.vue?vue&type=style&index=0&id=f6ff51e0&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ff51e0"]])

export default __exports__